{
  "title": "Cause Fear",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "1st-level necromancy",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You awaken the sense of mortality in one creature you can see within range. A construct or an undead is immune to this effect. The target must succeed on a Wisdom saving throw or become frightened of you until the spell ends. The frightened target can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, you can target one additional creature for each slot level above 1st. The creatures must be within 30 feet of each other when you target them."
  ],
  "spellLists": ["warlock", "wizard"]
}
